'use client';

import { Button, Tag } from '@lulalife/design-system';
import { XClose } from '@lulalife/design-system/icons/line';

type SettingsFilterChipProps = {
  label: string;
  onClear: () => void;
  /** The clear button's accessible name. */
  clearLabel?: string;
  'data-testid'?: string;
};

/**
 * A single active filter, shown as a tag with its own clear control — e.g.
 * "Filtered by role: Coordinator ×" on the Users tab, arrived at via "View
 * users" from the reassign-before-delete block (PEG-861/862).
 *
 * Its own file because Tailwind utilities only compile out of
 * `src/components/DS/**` (see the barrel's header comment) — the layout classes
 * this needs cannot live in the settings view that renders it.
 */
export const SettingsFilterChip = ({
  label,
  onClear,
  clearLabel = 'Clear filter',
  'data-testid': dataTestId,
}: SettingsFilterChipProps) => (
  <div data-lula-ds="" className="flex items-center gap-space-8 font-sans" data-testid={dataTestId}>
    <Tag color="neutral" label={label} />
    <Button
      variant="tertiary"
      iconOnly
      aria-label={clearLabel}
      data-testid={dataTestId ? `${dataTestId}.clear` : undefined}
      onClick={onClear}
    >
      <XClose aria-hidden="true" />
    </Button>
  </div>
);

export default SettingsFilterChip;
